import { HttpStatusCode } from '@angular/common/http';

export function allowStatus400() {
  return function (
    _target: Object,
    _method: string,
    descriptor: PropertyDescriptor,
  ) {
    const originalMethod = descriptor.value;
    descriptor.value = async function (...args: any[]) {
      try {
        const result = await originalMethod.apply(this, args);
        return result;
      } catch (e) {
        if (e.status === HttpStatusCode.BadRequest) {
          return {
            success: false,
            error: e.error.message,
          };
        }
        throw e;
      }
    };
    return descriptor;
  };
}
